export default {"src":"/_next/static/media/0xa05478b34fad86cc86f07eb6698c69ea60b266e3.669f6e99.svg","height":187,"width":183,"blurWidth":0,"blurHeight":0};